import { useLazyQuery } from "@apollo/client/react";import React, { useEffect, useMemo, useState } from "react";
import Box from "@mui/material/Box";
import DataGridGenerico from "../../../../components/dataGrid/DataGridGenerico";
import { useDialogs } from "../../../../hooks/useDialogs";
import { TabIndicacionHeader } from "../components/TabIndicacion/TabIndicacionHeader";
import { EmptyState } from "../../../../components/EmptyState/EmptyState";
import { useTabIndicacionRows } from "../hooks/TabIndicacion/useTabIndicacionRows";
import { useTabIndicacionColumns } from "../hooks/TabIndicacion/useTabIndicacionColumns";
import { TabIndicacionHistoryDialog } from "../components/TabIndicacion/TabIndicacionHistoryDialog";
import { TabIndicationAddIndicacionDialog } from "../components/TabIndicacion/TabIndicationAddIndicacionDialog";
import { TabIndicationDeleteIndicacionDialog } from "../components/TabIndicacion/TabIndicationDeleteIndicacionDialog";
import { TabIndicationEditIndicacionDialog } from "../components/TabIndicacion/TabIndicationEditIndicacionDialog";
import { TabIndicationViewIndicacionDialog } from "../components/TabIndicacion/TabIndicationViewIndicacionDialog";
import { TabIndicationViewSolicitudDialog } from "../components/TabIndicacion/TabIndicationViewSolicitudDialog";
import { GET_INDICACIONES_SOLIC_BY_ID_EVALUACION } from "../../../../data/graphQL/queries/GestionAsistencial/getIndicacionesSolicitudesByIdEvaluacion";

import { getTabIndicacionSolicitudEstadoChip } from "../hooks/TabIndicacion/getTabIndicacionSolicitudEstadoChip";
import { generateColumnsDefaultConfiguration } from "../../../../components/dataGrid/columnHelpers";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { GET_INDICATIONS_BY_EVALUACION } from "../../../../data/graphQL/queries/ResumenIngresoValidation/getIndicacionesByEvaluacion";

export const TabIndicacion = ({
  evaluacionSelected,
  allowedWrite
}) => {

  const [indicationSelected, setIndicationSelected] = useState(null);
  const [solicitudSelected, setSolicitudSelected] = useState(null);
  const { dialogs, handleOpenDialog, handleCloseDialog } = useDialogs({
    showHistory: false,
    addIndication: false,
    editIndication: false,
    deleteIndication: false,
    viewIndication: false,
    viewSolicitud: false
  });

  const [editOption, setEditOption] = useState(false);

  const handleOpenDeleteDialog = (idIndicacion) => {
    setIndicationSelected(idIndicacion);
    handleOpenDialog("deleteIndication");
  };

  const handleCloseDeleteDialog = () => {
    setIndicationSelected(null);
    handleCloseDialog("deleteIndication");
  };

  const handleCloseViewDialog = () => {
    setIndicationSelected(null);
    handleCloseDialog("viewIndication");
  };

  const handleCloseViewSolicitudDialog = () => {
    setSolicitudSelected(null);
    handleCloseDialog("viewSolicitud");
  };


  const handleOpenEditDialog = (idIndicacion) => {
    setIndicationSelected(idIndicacion);
    setEditOption(true);
    handleOpenDialog("editIndication");
  };

  const handleCloseEditDialog = () => {
    setIndicationSelected(null);
    setEditOption(false);
    handleCloseDialog("editIndication");
  };

  const handleOpenViewDialog = (idIndicacion) => {
    setIndicationSelected(idIndicacion);
    handleOpenDialog("viewIndication");
  };

  const handleOpenViewSolicitudDialog = (idIndicacionAprobacion) => {
    setSolicitudSelected(idIndicacionAprobacion);
    handleOpenDialog("viewSolicitud");
  };

  const [indicacioneComerciales, setIndicacionesComerciales] = useState([]);
  const [getIndicacionesComerciales, { data: dataIndicacionesComerciales, loading: loadingIndicacionesComercial }] = useLazyQuery(GET_INDICATIONS_BY_EVALUACION, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!loadingIndicacionesComercial)
    getIndicacionesComerciales({variables: { idEvaluacion: evaluacionSelected.idEvaluacion }});
  }, [evaluacionSelected.idEvaluacion]);

  useEffect(() => {
    if (!dataIndicacionesComerciales) return;
    setIndicacionesComerciales(dataIndicacionesComerciales?.indicacionesRIByIdEvaluacion);
  }, [dataIndicacionesComerciales]);

  const { rows, totalCount, loading, refetch, deleteRow } =
  useTabIndicacionRows(evaluacionSelected.idEvaluacion);

  const columns = useTabIndicacionColumns(
    handleOpenDeleteDialog,
    handleOpenEditDialog,
    handleOpenViewDialog,
    allowedWrite,
    indicacioneComerciales
  );

  useEffect(() => {
    if (!loadingSolicitudes)
    getSolicitudes({variables: { idEvaluacion: evaluacionSelected.idEvaluacion }});
  }, [evaluacionSelected.idEvaluacion]);

  const [rowsSolicitudes, setRowsSolicitudes] = useState([]);
  const [totalCountSolicitudes, setTotalCountSolicitudes] = useState();
  const [getSolicitudes, { data: dataSolicitudes, loading: loadingSolicitudes }] = useLazyQuery(GET_INDICACIONES_SOLIC_BY_ID_EVALUACION, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataSolicitudes) return;
    setRowsSolicitudes(dataSolicitudes?.indicacionesSolicitudesByIdEvaluacion?.valorEsperado);
    setTotalCountSolicitudes(dataSolicitudes?.indicacionesSolicitudesByIdEvaluacion?.valorEsperado.length);
  }, [dataSolicitudes]);


  const initialColumns = [
  {
    headerName: "",
    field: "action",
    flex: 0.02,
    renderCell: (cellProps) => {
      const { row } = cellProps;
      return (
        <div
          onClick={() => handleOpenViewSolicitudDialog(row)} aria-hidden='true'
          className="item-option clickable-option"
          style={{ paddingTop: '5px' }}>
          
            <VisibilityIcon className="edit-icon" />
          </div>);

    }
  },
  {
    flex: 0.05,
    field: "idIndicacionAprobacion",
    headerName: "#"
  },
  {
    flex: 0.2,
    field: "solicitante",
    headerName: "Solicitante"
  },
  {
    flex: 0.15,
    field: "periodo",
    headerName: "Fecha nueva indicación"
  },
  {
    flex: 0.1,
    field: "fechaAlta",
    headerName: "Fecha alta"
  },
  {
    flex: 0.1,
    field: "estadoMedico",
    headerName: "Respuesta Médica",
    headerAlign: 'center',
    align: 'center',
    renderCell: (cellProps) => {
      const { row } = cellProps;
      return getTabIndicacionSolicitudEstadoChip(row.idEstadoMedico);
    }
  },
  {
    flex: 0.1,
    field: "estadoComercial",
    headerName: "Respuesta Comercial",
    renderCell: (cellProps) => {
      const { row } = cellProps;
      return getTabIndicacionSolicitudEstadoChip(row.idEstadoComercial);
    }
  }];


  const columnsSolicitudes = useMemo(() => generateColumnsDefaultConfiguration(initialColumns, true), [rowsSolicitudes]);

  return (
    <>
      {!loading || !totalCount ?
      <Box>
          <TabIndicacionHeader
          handleOpenDialog={handleOpenDialog}
          disabled={!allowedWrite ||
          rowsSolicitudes != null && rowsSolicitudes?.filter((r) => r.idEstadoMedico == 1 || r.idEstadoComercial == 1).length > 0
          } />
        
          <DataGridGenerico
          columns={columns}
          totalCount={totalCount}
          rows={rows}
          toolbar={false}
          loading={loading}
          maxWidth={columns.reduce(
            (total, column) => total + (column.width || 0),
            0
          )} />
        
        </Box> :

      <EmptyState
        text={"No se ha agregado ninguna indicación"}
        buttonText={"Agregar"}
        onClick={() => handleOpenDialog("addIndication")} />

      }

      <br />
      <h3>Solicitud</h3>      
      {!loadingSolicitudes || !totalCountSolicitudes ?
      <Box>
          <DataGridGenerico
          columns={columnsSolicitudes}
          totalCount={totalCountSolicitudes}
          rows={rowsSolicitudes}
          toolbar={false}
          loading={loadingSolicitudes}
          maxWidth={columns.reduce(
            (total, column) => total + (column.width || 0),
            0
          )} />
        
        </Box> :

      <EmptyState
        text={"No se ha agregado ninguna solicitud"} />

      }

      {dialogs.showHistory &&
      <TabIndicacionHistoryDialog
        open={dialogs.showHistory}
        handleCloseDialog={() => handleCloseDialog("showHistory")}
        idEvaluacion={evaluacionSelected.idEvaluacion}
        evaluacionSelected={evaluacionSelected} />

      }

      {dialogs.addIndication &&
      <TabIndicationAddIndicacionDialog
        open={dialogs.addIndication}
        handleCloseDialog={() => handleCloseDialog("addIndication")}
        idEvaluacion={evaluacionSelected.idEvaluacion}
        refetch={refetch}
        refetchSolicitudes={() => getSolicitudes({variables: { idEvaluacion: evaluacionSelected.idEvaluacion }})} />

      }

      {dialogs.editIndication &&
      <TabIndicationEditIndicacionDialog
        open={dialogs.editIndication}
        handleCloseDialog={handleCloseEditDialog}
        idEvaluacion={evaluacionSelected.idEvaluacion}
        indicationSelected={indicationSelected}
        refetch={refetch} />

      }

      {dialogs.deleteIndication &&
      <TabIndicationDeleteIndicacionDialog
        open={dialogs.deleteIndication}
        handleCloseDialog={handleCloseDeleteDialog}
        indicationSelected={indicationSelected}
        deleteRow={deleteRow} />

      }

      {dialogs.viewIndication &&
      <TabIndicationViewIndicacionDialog
        open={dialogs.viewIndication}
        handleCloseDialog={handleCloseViewDialog}
        indicationSelected={indicationSelected} />

      }

      {dialogs.viewSolicitud &&
      <TabIndicationViewSolicitudDialog
        open={dialogs.viewSolicitud}
        handleCloseDialog={handleCloseViewSolicitudDialog}
        solicitudSelected={solicitudSelected} />

      }
    </>);

};